import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import keycloak from '@/utils/keycloak'
import common from '@/utils/common'
import print from 'vue-print-nb';


Vue.config.productionTip = false
// Vue.use(keycloak)
Vue.prototype.$keycloak = keycloak
Vue.prototype.$common = common
Vue.use(print)


//服用组件-loading
Vue.component('loading_', {
  model: {

  },
  props: {

  },
  data: function data() {
    return {

    };
  },
  computed: {

  },
  mounted: function mounted() {

  },
  methods: {

  },
  template:
    '        <div class=\'loading\'>\n' +
    '            <div class=\'loading_shawl\'>\n' +
    '            </div>\n' +
    '            <img src=\'loading.png\' />\n' +
    '        </div>'
})

//复用组件-分页
Vue.component('my_page', {
  model: {
    prop: 'pageNo',
    event: 'jumpPage'
  },
  props: {
    pagesize: {
      type: Number,
      default: 1
    },
    pageNo: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      jumpPage: ''
    }
  },
  computed: {
    prevDisable: function () {
      if (this.pageNo > 1) {
        return false;
      } else {
        return true;
      }
    },
    nextDisable: function () {
      if (this.pageNo < this.pagesize && this.pagesize > 1) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted: function mounted() {

  },
  methods: {
    jumpPrev: function jumpPrev() {
      var _this = this;
      if (_this.pageNo === 1) {
        return false;
      } else {
        _this.$emit('jumpPage', _this.pageNo - 1);
        _this.$emit('on-jump', _this.pageNo - 1);
      }
    },
    jumpNext: function jumpNext() {
      var _this = this;
      if (_this.pageNo === _this.pagesize) {
        return false;
      } else {
        _this.$emit('jumpPage', _this.pageNo + 1);
        _this.$emit('on-jump', _this.pageNo + 1);
      }
    },
    jump: function jump(id) {
      var _this = this;
      if (id > _this.pagesize) {
        id = _this.pagesize;
      }
      _this.$emit('jumpPage', id);
      _this.$emit('on-jump', id);
    },
    /**
     * @return {boolean}
     */
    Go: function Go() {
      var _this = this;
      if (_this.jumpPage === '') {
        return false;
      } else if (/^\d*$/.test(parseInt(_this.jumpPage))) {
        _this.jump(parseInt(_this.jumpPage));
        _this.jumpPage = '';
      } else {
        _this.jumpPage = '';
        return false;
      }
    }
  },
  template:
    '        <div class=\'pager-wrapper\' ref=\'pager\'>\n' +
    '            <div class=\'pager-box\'>\n' +
    '                <a class=\'pager-prev\' :class="{\'pager-disabled\':prevDisable}" href=\'javascript:;\' @click=\'jumpPrev()\'>上一页</a>\n' +
    '                <template v-for=\'i in pagesize\'>\n' +
    '                    <span v-if=\'i==pageNo\' class=\'pager-curr\'>\n' +
    '                        <em class=\'pager-em\'></em><em>{{i}}</em>\n' +
    '                    </span>\n' +
    '                    <a v-else-if=\'pageNo<5&&(i)<6\' href=\'javascript:;\' @click=\'jump(i)\'>\n' +
    '                        {{i}}\n' +
    '                    </a>\n' +
    '                    <a v-else-if=\'pagesize<7||i==1||i==pagesize||(pageNo-2<=i&&i<=pageNo+2)\' href=\'javascript:;\' @click=\'jump(i)\'>\n' +
    '                        {{i}}\n' +
    '                    </a>\n' +
    '                    <template v-else>\n' +
    '                        <span v-if=\'pageNo<5&&i==6\' class=\'pager-spr\'>…</span>\n' +
    '                        <span v-if=\'pageNo==4&&i==7\' class=\'pager-spr\'>…</span>\n' +
    '                        <span v-if=\'pageNo>4&&i==pageNo-3\' class=\'pager-spr\'>…</span>\n' +
    '                        <span v-if=\'pageNo>4&&i==pageNo+3\' class=\'pager-spr\'>…</span>\n' +
    '                    </template>\n' +
    '                </template>\n' +
    '                <a class=\'pager-next\' :class="{\'pager-disabled\':nextDisable}" href=\'javascript:;\' @click=\'jumpNext()\'>下一页</a>\n' +
    '            </div>\n' +
    '            <div class=\'pager-input\'>\n' +
    '                <input type=\'text\' v-model=\'jumpPage\'>\n' +
    '                <a class=\'pager-btn-go\' href=\'javascript:;\' @click=\'Go()\'>GO</a>\n' +
    '            </div>\n' +
    '        </div>'
})

// 复用组件-过滤器
// v-model 默认使用value属性名，和input事件名
// 组件中的model用于双向绑定，定义名字和事件，在父组件中v-model后进行双向绑定
Vue.component('my_filter', {
  model: {

  },
  props: {
    title: {
      Type: String,
      default: ''
    },
    string_data: {
      Type: Array,
      default: () => []
    },
    int_data: {
      Type: Array,
      default: () => []
    },
    double_data: {
      Type: Array,
      default: () => []
    }
  },
  data: function data() {
    return {
      status: 0,
      span_css: ['pibdr_name pibdr_4x'],
      input_css: ['txt_general', 'txt_long']
    };
  },
  computed: {

  },
  mounted: function mounted() {

  },
  methods: {
    close: function close() {
      var _this = this;
      _this.$emit('filter_close');
    },
    search: function search() {
      var _this = this;
      // 在这里把所有的data转化成字典
      var dic = {}
      _this.string_data.forEach((item) => {
        dic[item.name] = item.value
      })
      _this.int_data.forEach((item) => {
        dic[item.name] = item.value
      })
      _this.double_data.forEach((item) => {
        dic[item.name] = item.value
      })
      _this.$emit('filter_search', dic);
    },
    initFilterData: function initFilterData() {
      // var _this = this;

    }
  },
  template:
    '            <div class=\'common_info\'>\n' +
    '                <div class=\'common_info_opacity\'>\n' +
    '                </div>\n' +
    '                <div class=\'common_info_box\'>\n' +
    '                    <div class=\'common_info_box_div\'>\n' +
    '                        <div class=\'common_info_box_div_top pibdr_title\'>\n' +
    '                            <span>{{title}}</span>\n' +
    '                        </div>\n' +
    '                        <div style="width: 100%; height: 55px">\n' +
    '                        </div>\n' +
    '                        <div v-for=\'item in string_data\' v-bind:key=\'item.name\' >\n' +
    '                         <div class=\'common_info_box_div_row cibdr_10\'>\n' +
    '                              <span :class=\'span_css[item.span_css]\'>{{item.title}}:</span>' +
    '                              <input :class=\'input_css[item.input_css]\' :maxlength=\'item.max\' type="text" style=\'color: #418fa6\' v-model=\'item.value\'/>\n' +
    '                         </div>\n' +
    '                        </div>\n' +
    '                        <div class=\'common_info_box_div_bottom\'>\n' +
    '                            <input class="cibb_save" type=\'button\' value=\'搜索\' @click=\'search\'>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class=\'common_info_close\' @click=\'close\'>\n' +
    '                        关闭\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>'
})

Vue.component('my_editor', {
  model: {

  },
  props: {
    demo_data: {},
    editor_title: {
      Type: String,
      default: ''
    },
    data_index: {
      Type: Number,
      default: -1
    },
    item_string_data: {
      Type: Array,
      default: () => []
    },
    item_int_data: {
      Type: Array,
      default: () => []
    },
    item_double_data: {
      Type: Array,
      default: () => []
    }
  },
  data: function data() {
    return {
      span_css: ['pibdr_name pibdr_4x'],
      input_css: ['txt_long', 'textarea_half textarea_normal', 'textarea_half textarea_high', 'textarea_half textarea_mid']
    };
  },
  computed: {

  },
  mounted: function mounted() {
    
  },
  methods: {
    close: function close() {
      var _this = this;
      _this.$emit('editor_close');
    },
    save: function save() {
      var _this = this;
      var dic = {}
      _this.item_string_data.forEach((item) => {
        dic[item.name] = item.value
      })
      _this.item_int_data.forEach((item) => {
        dic[item.name] = item.value
      })
      _this.item_double_data.forEach((item) => {
        dic[item.name] = item.value
      })
      _this.$emit('editor_save', dic);
    }
  },
  template:
    '        <div class=\'common_info\'>\n' +
    '            <div class=\'common_info_opacity\'>\n' +
    '            </div>\n' +
    '            <div class=\'common_info_box\'>\n' +
    '                <div class=\'common_info_box_div\'>\n' +
    '                    <div class=\'common_info_box_div_top pibdr_title\'>\n' +
    '                        <span>{{editor_title}}</span>\n' +
    '                    </div>\n' +
    '                    <div style="width: 100%; height: 55px">\n' +
    '                    </div>\n' +
    '                    <div v-for=\'item in item_string_data\' v-bind:key=\'item.name\'>\n' +
    '                     <div class=\'common_info_box_div_row cibdr_10 clear\'>\n' +
    '                          <span :class=\'span_css[item.span_css]\' style=\'float: left\'>{{item.title}}:</span>' +
    '                          <textarea :class=\'input_css[item.input_css]\' :maxlength="item.max" type="text" style=\'color: #418fa6; float: left; margin-top: 6px\' v-model=\'item.value\'></textarea>\n' +
    '                     </div>\n' +
    '                    </div>\n' +
    '                    <div style="width: 100%; height: 30px">\n' +
    '                    </div>\n' +
    '                    <div class=\'common_info_box_div_bottom\'>\n' +
    '                        <input class="cibb_save" type=\'button\' value=\'保存\' @click=\'save\'>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class=\'common_info_close\' @click=\'close\'>\n' +
    '                    关闭\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>'
});

router.beforeEach((to, from, next) => {
  //这里做路由
  const auth = require('@/router/auth').default
  auth.redirectIfNotAuthenticated(to, from, next)
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
